import { useLingui } from '@lingui/react/macro';

import { MobileBrandFilter } from '@/components/SharedFilters/BrandFilter/MobileBrandFilter';

import { useFilters } from '../FiltersState';

export const FiltersBrand = () => {
  const { t } = useLingui();

  const {
    brands: { brands, setBrands },
  } = useFilters();

  return (
    <MobileBrandFilter
      filterId="brands"
      selectedBrands={brands}
      setSelectedBrands={setBrands}
      brandsQuery={{ limit: 500, offset: 0 }}
      label={t({ id: 'requests.filters.brand.label', message: 'Item brand' })}
    />
  );
};
